export default function processWrapper (currentStepAttribute) {
  return {
    methods: {
      showStep (checkStep) {
        return this[currentStepAttribute] === checkStep
      }
    }
  }
}
